import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { CurrentDealAppointment } from "Types/state";
import { formatDateForDisplay } from "./lib";
import ScheduleAppointmentSuccess from "./ScheduleAppointmentSuccess";

function mapStateToProps({ account, currentDeal, tradeIn, vehicles }: ApplicationStore) {
    const { appointment, vin } = currentDeal;
    const { date, time } = appointment as CurrentDealAppointment;

    return {
        account,
        appointmentDate: formatDateForDisplay(date),
        appointmentTime: time,
        hasTradePending: !!tradeIn.ymmt,
        tradePendingBalance: tradeIn.balance,
        vehicle: vehicles.entities[vin!],
    };
}

export default connect(mapStateToProps)(ScheduleAppointmentSuccess);
